export const STEPS = ['Create Account', 'Set user details', 'Account settings', 'Check your email'];

export const atLeastEightChars = password => password.length > 7;
export const atLeastOneLower = password => /(.*[a-z].*)/.test(password);
export const atLeastOneUpper = password => /(.*[A-Z].*)/.test(password);
export const atLeastOneNumberOrSymbol = password =>
	/(.*[0-9\!\@\#\$\%\^\&\*\(\)\±\~\?\{\}\|\”\<\>].*)/.test(password);
